import React, { RefObject, useEffect, useRef } from 'react';
import { translate } from 'components/Translation';
import style from 'assets/jss/material-dashboard-pro-react/views/services/FixedBusinessBroadband/linesStyle';
import { Link, makeStyles } from '@material-ui/core';
import { BodyM, BodySBold } from 'components/Typography/Typography';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import InfoClause from 'components/infoClause/infoClause';
import { useSelector } from 'react-redux';
import { getFiberProLabels } from 'redux/modules/dynamicLabels/selectors';

// @ts-ignore
const useStyles = makeStyles(style);

interface ILinesProps {
	handleIncreaseNumberOfLines: VoidFunction;
	setNextStepDisabled: (nextStepDisabled: boolean) => void;
	linesEl: React.ReactElement[];
}

const LinesTabFBB = (props: ILinesProps) => {
	// this component get focussed - for accessibility
	const ref: RefObject<HTMLDivElement> = useRef(null);
	useEffect(() => {
		if (ref.current) ref.current.focus();
	}, []);
	const { handleIncreaseNumberOfLines, setNextStepDisabled, linesEl } = props;
	const fiberProLabels = useSelector(getFiberProLabels);
	const classes = useStyles();

	useEffect(() => {
		setNextStepDisabled(false);
	}, [setNextStepDisabled]);

	return (
		<div ref={ref} tabIndex={0}>
			<div className={classes.subtitle}>
				<BodyM color="secondary-light" disableMargin>
					{fiberProLabels.max4Lines}
				</BodyM>
			</div>

			<div>
				{linesEl}
				<ConditionalRender
					show={linesEl.length <= 3}
					onTrue={() => (
						<Link href="#" underline="always" onClick={() => handleIncreaseNumberOfLines()}>
							<BodySBold customClassName={classes.addMoreLines}>{fiberProLabels.addMoreLines}</BodySBold>
						</Link>
					)}
				/>
			</div>
			{fiberProLabels.contactBannerMoreLines && <InfoClause message={fiberProLabels.contactBannerMoreLines} />}
		</div>
	);
};

export default LinesTabFBB;
